import { withErrorBoundary, Spinner, NoResults } from 'shared'
import { MissingImage } from 'customizations'
import classNames from 'classnames'
import { absolutizePath } from 'shared/util'
import ParkCardBadge from './ParkCardBadge'
import ParkReservationSlots from './ParkReservationSlots'
import { useEffect, useState, useMemo } from 'react';
import { SmartButtonLink } from 'ui/smart-buttons'

function ParkCard({ park, base = park.baseCollectionName }) {
  const [timeSlots, setTimeSlots] = useState([])
  const [loading, setLoading] = useState(true)

  let isCommunityPage = application.path.includes('/community-calendar') ||
    application.path.includes('/places-calendar') ||
    application.path.includes('/admin-places-calendar');

  const date = useMemo(() => moment(application.todayDateString), []);


  useEffect(() => {
    if (isCommunityPage) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const data = await ParkApi.loadTimeSlotsForDate(park, date, null);
          setTimeSlots(data);
        } catch (error) {
          console.error("Failed to fetch time slots:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [isCommunityPage, park, date]);

  const renderItem = (slot) => {
    let { time, reservation, available, militaryTime } = slot
    let options = { }

    if (reservation) {
      options = {
        text: (
          <>
            Cancel: {slot.desc}
             {reservation.user_name && <br />}{reservation.user_name}
             {reservation.note && <br />}{reservation.note}
          </>
        ),
        className: classNames( 'btn-sm park-reservation-btn', { gray: true }),
        key: time,
      }
    } else {
      options = {
        text: (
          <>
            Open: {slot.desc}<br />
            {slot.res_user_name && <br />}{slot.res_user_name}
             {slot.res_note && <br />}{slot.res_note}
          </>
        ),
        className: 'btn-sm park-reservation-btn',
        key: time,
      }
    }

    if (User.current && User.current.guest) {
      options.click = () => {
        App.state.setObjectSilent({ afterSignupPath: App.path })
        App.go(`${base}/guest-signup`)
      }
    }
      let url = `${base}/${park.uid}`
      return <SmartButtonLink to={url} {...options} click={null} />
  }

  return (
    <custom-card className={classNames('ParkCard', park.has_events && 'with-events')}>
      <Link to={`${absolutizePath(base)}/${park.uid}`} className='plain-link'>
        <div className="park-card">
          <div className="card-img-container">
            <img className="card-img-top"
              src={park.image_preview_url || MissingImage}
              alt={park.name}
            />
          </div>
          <div className="card-meta">
            <h5 className="card-heading">{park.name}</h5>
            { park.isFeatureEnabled('opening') && <div className="card-note new-card-note">{park.opening_status_str}</div> }
            <ParkCardBadge park={park} /> 
          </div>

        </div>
      </Link>
      {

        isCommunityPage &&

        <div className="park-reservation-time-slots">
          {loading ? (
            <Spinner />
          ) : timeSlots.length ? (
            timeSlots.map((ts) => renderItem(ts))
          ) : (
            <NoResults className="compact">No Availability Today</NoResults>
          )}
        </div>
      }
    </custom-card>
  )
}

export default withErrorBoundary(ParkCard)
